"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDayPickerSingle = void 0;
/** Returns true when the props are of type [[DayPickerSingle]]. */
function isDayPickerSingle(props) {
    return props.mode === 'single';
}
exports.isDayPickerSingle = isDayPickerSingle;
//# sourceMappingURL=isDayPickerSingle.js.map